import React from "react";
import { AuthProvider } from "./authContext";
import { ResponsiveProvider } from "./responsiveContext";
import QueryStateProvider from './queryContext'

const RootContext = ({ children }) => {
  return (
    <AuthProvider>
      <QueryStateProvider>
        <ResponsiveProvider>{children}</ResponsiveProvider>
      </QueryStateProvider>
    </AuthProvider>
  )
};

export default RootContext;
